var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStructuralHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.572,
    height: 53.571,
    viewBox: "0 0 53.572 53.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44418",
    "data-name": "Group 44418",
    transform: "translate(-6396.712 4965.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26653",
    "data-name": "Path 26653",
    d: "M43.906,106.2v-2.637H40.391V100.93H36.876V98.294H33.36v19.335H47.422V106.2Z",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22176",
    "data-name": "Rectangle 22176",
    width: 15.819,
    height: 33.4,
    transform: "translate(6401.985 -4945.706)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22177",
    "data-name": "Rectangle 22177",
    width: 5.273,
    height: 5.273,
    transform: "translate(6427.71 -4923.735)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22178",
    "data-name": "Rectangle 22178",
    width: 5.273,
    height: 5.273,
    transform: "translate(6434.464 -4923.735)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26654",
    "data-name": "Path 26654",
    d: "M51.816,117.016V98.248l-2.637-.864V85.046H44.785V82.454H43.027v2.592H41.269v-4.32H39.508v4.32H37.75V79H35.992v6.048H31.6v6.577l-2.637-.864v26.257H27.208v15.553H53.574V117.016ZM33.36,90.231h9.667V88.5H33.36V86.774H47.422V88.5H44.785v1.728h2.637V96.8L33.36,92.2Zm-2.637,2.928L50.058,99.5v17.518H48.3V106.648H46.542v10.368H44.784V104.055H43.026v12.961H41.268V101.463h-1.76v15.553H37.75V98.871H35.992v18.145H34.234V96.279H32.476v20.737H30.718Zm-1.758,37.683v-1.729H47.421v-1.728H28.966v-8.641h22.85v8.641H49.179v1.728h2.637v1.728Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26655",
    "data-name": "Path 26655",
    d: "M24.61,87.639H22.852V84.182H21.095V79H5.275v5.184H3.517v3.457H1.76V91.1H0v41.471H26.368V91.1H24.61ZM7.033,80.726h12.3v3.456H7.033ZM5.275,85.91h15.82v1.729H5.275ZM3.517,89.367H22.852V91.1H3.517ZM1.76,130.841V96.279H19.337V94.551H1.76V92.823H24.61v1.728H21.095v1.728H24.61v34.562Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22179",
    "data-name": "Rectangle 22179",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4945.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22180",
    "data-name": "Rectangle 22180",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4945.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22181",
    "data-name": "Rectangle 22181",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4945.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22182",
    "data-name": "Rectangle 22182",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4945.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22183",
    "data-name": "Rectangle 22183",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4945.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22184",
    "data-name": "Rectangle 22184",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4940.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22185",
    "data-name": "Rectangle 22185",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4940.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22186",
    "data-name": "Rectangle 22186",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4940.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22187",
    "data-name": "Rectangle 22187",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4940.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22188",
    "data-name": "Rectangle 22188",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4940.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22189",
    "data-name": "Rectangle 22189",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4935.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22190",
    "data-name": "Rectangle 22190",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4935.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22191",
    "data-name": "Rectangle 22191",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4935.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22192",
    "data-name": "Rectangle 22192",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4935.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22193",
    "data-name": "Rectangle 22193",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4935.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22194",
    "data-name": "Rectangle 22194",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4929.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22195",
    "data-name": "Rectangle 22195",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4929.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22196",
    "data-name": "Rectangle 22196",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4929.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22197",
    "data-name": "Rectangle 22197",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4929.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22198",
    "data-name": "Rectangle 22198",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4929.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22199",
    "data-name": "Rectangle 22199",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4924.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22200",
    "data-name": "Rectangle 22200",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4924.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22201",
    "data-name": "Rectangle 22201",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4924.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22202",
    "data-name": "Rectangle 22202",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4924.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22203",
    "data-name": "Rectangle 22203",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4924.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22204",
    "data-name": "Rectangle 22204",
    width: 1.758,
    height: 1.758,
    transform: "translate(6401.985 -4919.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22205",
    "data-name": "Rectangle 22205",
    width: 1.758,
    height: 1.758,
    transform: "translate(6405.5 -4919.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22206",
    "data-name": "Rectangle 22206",
    width: 1.758,
    height: 1.758,
    transform: "translate(6409.017 -4919.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22207",
    "data-name": "Rectangle 22207",
    width: 1.758,
    height: 1.758,
    transform: "translate(6412.531 -4919.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22208",
    "data-name": "Rectangle 22208",
    width: 1.758,
    height: 1.758,
    transform: "translate(6416.047 -4919.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26656",
    "data-name": "Path 26656",
    d: "M47.535,125.538a.842.842,0,0,0,.841-.841v-.845h.841a.841.841,0,1,0,0-1.682h-.841v-.841a.841.841,0,1,0-1.682,0v.843h-.839a.841.841,0,1,0,0,1.682H46.7v.841a.841.841,0,0,0,.837.845Z",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26657",
    "data-name": "Path 26657",
    d: "M24.32,83.751a2.116,2.116,0,1,0,2.116-2.116,2.116,2.116,0,0,0-2.116,2.116m2.821,0a.7.7,0,1,1-.7-.705.705.705,0,0,1,.7.705",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuralHover);
export default __webpack_public_path__ + "static/media/structuralHover.61f048b0ec56f916e647373e592212e2.svg";
export { ForwardRef as ReactComponent };